import styled from '@emotion/styled'
import { LoyaltyPerk, LoyaltyProgram } from '@open-tender/types'
import {
  LoyaltyHeader,
  LoyaltyRewards,
  LoyaltyStatus,
  ProgressSpend,
} from 'components'

const LoyaltyVisitsView = styled.div``

const LoyaltyVisits = ({
  program,
  perk,
  to,
}: {
  program: LoyaltyProgram
  perk?: LoyaltyPerk | null
  to?: string
}) => {
  const { name, description, loyalty_type, spend_name } = program
  const { credit, progress, threshold, rewards } = perk || {}
  return (
    <LoyaltyVisitsView>
      <LoyaltyHeader title={name} subtitle={description} />
      {credit && (
        <LoyaltyStatus
          count={progress ? progress.replace('.00', '') : 0}
          name={spend_name}
          to={to}
        />
      )}
      {progress && threshold ? (
        <ProgressSpend
          loyaltyType={loyalty_type}
          spendName={spend_name}
          progress={progress}
          threshold={threshold}
        />
      ) : null}
      {rewards && <LoyaltyRewards rewards={rewards} />}
    </LoyaltyVisitsView>
  )
}

export default LoyaltyVisits
